export default __webpack_public_path__ + "static/media/place_holder.f4b4dfc2.jpg";